import React from 'react';
import { APP } from '../app/appConfig';

const Contact: React.FC = () => (
  <main id="main" className="mx-auto max-w-3xl px-4 sm:px-6 py-16">
    <h1 className="text-h1 font-display font-semibold mb-6">Contact</h1>
    <div className="space-y-5 text-body text-text-secondary leading-relaxed">
      <p>
        For questions, corrections, or to share recordings, please reach out to The{' '}
        {APP.brand.siteName} Team.
      </p>
      <a
        href={`mailto:${APP.brand.contactEmail}`}
        className="inline-flex items-center gap-2 text-accent-gold hover:underline"
      >
        {APP.brand.contactEmail}
      </a>
    </div>
  </main>
);

export default Contact;
